import React, { useEffect, useState } from "react";
import { ArrowLeft, Loader2, Sparkles } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { getPublicKbArticle } from "../services/knowledgeBaseService";
import PublicSupportModal from "../components/support/PublicSupportModal";
import "./HelpCenterPage.css";

export default function HelpArticlePage() {
    const { slug } = useParams();
    const navigate = useNavigate();

    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [supportModalOpen, setSupportModalOpen] = useState(false);

    useEffect(() => {
        loadArticle();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug]);

    const loadArticle = async () => {
        setLoading(true);

        try {
            const data = await getPublicKbArticle(slug);
            setArticle(data);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="help-page">
            <header className="help-header">
                <button className="help-back-btn" onClick={() => navigate("/help")}>
                    <ArrowLeft size={17} />
                    Back to Help
                </button>

                <div className="help-brand">
                    <Sparkles size={20} />
                    <strong>Help Article</strong>
                </div>

                <button
                    className="help-support-btn"
                    onClick={() => setSupportModalOpen(true)}
                >
                    Contact Support
                </button>
            </header>

            {loading ? (
                <div className="help-loading">
                    <Loader2 className="spin" size={26} />
                    Loading article...
                </div>
            ) : !article ? (
                <div className="help-empty">
                    <h3>Article not found</h3>
                    <p>The article may have been removed or unpublished.</p>
                </div>
            ) : (
                <main className="help-content">
                    <article className="help-article-detail">
                        <span>{article.categoryName}</span>
                        <h1>{article.title}</h1>
                        <p>{article.summary}</p>

                        <div
                            className="help-rich-body"
                            dangerouslySetInnerHTML={{ __html: article.bodyHtml }}
                        />
                    </article>
                </main>
            )}

            <PublicSupportModal
                open={supportModalOpen}
                onClose={() => setSupportModalOpen(false)}
            />
        </div>
    );
}